/* KAI RS - Napravi svoj set: logika (6. 10. 2026). Popust racuna Appstle po skritih oznakah vrstic. */
(function () {
  'use strict';
  document.querySelectorAll('.kss').forEach(init);
  function init(root) {
  var dataEl = root.querySelector('[data-kss-data]');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var MAX = 4, FREE = 1190000;
  var byK = {}; D.items.forEach(function (x) { byK[x.k] = x; });
  var units = [];
  var busy = false;

  function q(s) { return root.querySelector(s); }
  function fmt(c) {
    var v = c / 100, dec = Math.round(c) % 100 !== 0;
    try { return new Intl.NumberFormat('sr-RS', { minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: 2 }).format(v) + ' RSD'; }
    catch (e) { return Math.round(v) + ' RSD'; }
  }
  function count(k) { var n = 0; units.forEach(function (u) { if (u === k) n++; }); return n; }
  function rate(n) { return n >= 4 ? .20 : n >= 3 ? .15 : n >= 2 ? .10 : 0; }
  function kos(n) { return n === 1 ? 'proizvod' : 'proizvoda'; }
  var tT;
  function toast(t) { var el = q('[data-toast]'); el.textContent = t; el.classList.add('show'); clearTimeout(tT); tT = setTimeout(function () { el.classList.remove('show'); }, 1800); }

  root.querySelectorAll('[data-price]').forEach(function (el) {
    var k = el.closest('[data-k]').getAttribute('data-k'); if (byK[k]) el.textContent = fmt(byK[k].price);
  });

  function render() {
    var n = units.length, r = rate(n);
    var orig = units.reduce(function (s, k) { return s + byK[k].price; }, 0);
    var now = Math.round(orig * (1 - r));
    root.classList.toggle('kss-full', n >= MAX);
    root.querySelectorAll('.kss-pc').forEach(function (c) {
      var k = c.getAttribute('data-k'), c0 = count(k);
      c.classList.toggle('in', c0 > 0);
      c.querySelector('.kss-cnt').textContent = c0;
      var b = c.querySelector('.kss-step b'); if (b) b.textContent = c0;
    });
    var s = '';
    for (var i = 0; i < MAX; i++) {
      var k = units[i];
      s += k ? '<div class="kss-slot full" data-slot="' + i + '" title="Ukloni"><img src="' + byK[k].img + '" alt=""></div>' : '<div class="kss-slot"><span class="nb">' + (i + 1) + '</span></div>';
    }
    var slots = q('[data-slots]'), prev = slots.querySelectorAll('.kss-slot.full').length;
    slots.innerHTML = s;
    if (prev >= n) slots.querySelectorAll('img').forEach(function (im) { im.style.animation = 'none'; });
    q('[data-cnt]').textContent = n + ' / ' + MAX;
    var m;
    if (n === 0) m = 'Izaberi <b>2 proizvoda</b> i dobij <b>10% popusta</b>.';
    else if (n === 1) m = 'Još <b>1 proizvod</b> do <b>10% popusta</b> i maske gratis.';
    else if (n === 2) m = 'Imaš <b>10% popusta</b>. Još 1 do <b>15%</b>.';
    else if (n === 3) m = 'Imaš <b>15% popusta</b>. Još 1 do <b>20%</b> i besplatne dostave.';
    else m = 'Maksimalan popust: <b>20%</b>. Set je pun.';
    q('[data-msg]').innerHTML = m;
    q('[data-bar]').style.width = (n / MAX * 100) + '%';
    root.querySelectorAll('.kss-ticks [data-k]').forEach(function (t) { t.classList.toggle('on', n >= +t.getAttribute('data-k')); });
    root.querySelectorAll('.kss-tier').forEach(function (t) { var k2 = +t.getAttribute('data-t'); t.classList.toggle('on', n === k2 || (k2 === 4 && n >= 4)); });
    q('[data-pk="1"]').classList.toggle('on', n >= 1);
    q('[data-pk="2"]').classList.toggle('on', n >= 2);
    q('[data-pk2s]').textContent = n >= 2 ? '' : 'od 2 proizvoda';
    var free = n >= 4 || now >= FREE;
    q('[data-pk="3"]').classList.toggle('on', free);
    q('[data-pk3s]').textContent = free ? '' : (n ? 'još ' + fmt(FREE - now) : 'od 11.900 RSD');
    q('[data-old]').textContent = r ? fmt(orig) : '';
    q('[data-now]').textContent = fmt(now);
    q('[data-save]').textContent = r ? 'Uštedeo si ' + fmt(orig - now) : '';
    var cta = q('[data-cta]');
    if (n < 2) { cta.classList.add('kss-off'); cta.textContent = 'Izaberi još ' + (2 - n) + ' ' + kos(2 - n); }
    else { cta.classList.remove('kss-off'); cta.textContent = 'Dodaj set u korpu · ' + fmt(now); }
  }

  function refreshDrawer() {
    return fetch('/?section_id=api-cart-items', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
      var d = document.getElementById('cart-drawer'); if (!d) return false;
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var lines = doc.querySelector('[data-api-line-items]'), price = doc.querySelector('[data-api-cart-price]');
      var holder = d.querySelector('[data-items-holder]'), ph = d.querySelector('[data-cart-price-holder]');
      if (holder && lines) { holder.innerHTML = lines.innerHTML; holder.classList.remove('hidden'); }
      if (ph && price) ph.innerHTML = price.innerHTML;
      return true;
    });
  }

  function addSet() {
    if (busy || units.length < 2) return;
    busy = true;
    var cta = q('[data-cta]'); cta.classList.add('kss-busy'); cta.textContent = 'Dodajem...';
    var qtys = {}, order = [];
    units.forEach(function (k) { if (!qtys[k]) { qtys[k] = 0; order.push(k); } qtys[k]++; });
    var items = order.map(function (k) {
      var x = byK[k];
      return { id: x.vid, quantity: qtys[k], properties: {
        '_appstle-bb-id': D.bundleId, '__appstle-bb-name': D.bundleName,
        '_appstle-bundles-variants': x.vid, '_appstle_bundles_type': 'CLASSIC_BUILD_A_BOX',
        '_appstle_bundle_mandatory_products': '[]' } };
    });
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return refreshDrawer(); })
      .then(function (ok) {
        units = []; render(); toast('Set je u korpi. Pokloni se dodaju automatski.');
        var t = document.querySelector('[data-cart-drawer-toggle]');
        if (ok && t) t.click(); else window.location.href = '/cart';
      })
      .catch(function (e) { console.warn('KAI set:', e); toast('Greška, pokušaj ponovo.'); render(); })
      .then(function () { busy = false; cta.classList.remove('kss-busy'); });
  }

  function act(e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    var a = t.closest('[data-add]'), mi = t.closest('[data-min]'), sl = t.closest('[data-slot]'), cta = t.closest('[data-cta]');
    if (!a && !mi && !sl && !cta) return;
    e.preventDefault();
    if (a) {
      if (units.length >= MAX) { toast('Set je pun: najviše 4 proizvoda.'); return; }
      var k = a.getAttribute('data-add'); if (!byK[k] || !byK[k].ok) return;
      units.push(k);
      var n = units.length;
      toast(n === 2 ? 'Odlično! Otključao si 10% popusta.' : n === 3 ? 'Sada imaš 15% popusta.' : n === 4 ? 'Maksimalan popust 20% i besplatna dostava!' : byK[k].n + ' je u setu.');
      render();
    } else if (mi) {
      var i = units.lastIndexOf(mi.getAttribute('data-min')); if (i > -1) units.splice(i, 1); render();
    } else if (sl) {
      units.splice(+sl.getAttribute('data-slot'), 1); render();
    } else if (cta) {
      addSet();
    }
  }
  root.addEventListener('click', act);
  root.addEventListener('keydown', act);
  render();
  }
})();